

















































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../../RestClient";
import DateFormatter from "../../../shared/DateFormatter";
import PointerMenu from "../../general/PointerMenu.vue";
import Loading from "../../general/Loading.vue";

import RentalBookingJson, { defaultRentalBookingJson } from "../../../shared/RentalBookingJson";
import { RentalItemInfoJson } from "../../../shared/RentalItemJson";
import PriceUtils from "../../../shared/PriceUtils";

import { ValidationResult, Validation } from "../../../shared/Validation";
import { validateRentalConditionJson } from "../../../shared/RentalConditionJson";
import RentalItemJson from "../../../shared/RentalItemJson";
import RentalConditionJson from "../../../shared/RentalConditionJson";

type keysForCachedPrices = {
  [key in keyof Pick<RentalConditionJson, "price" | "cancellationFee">]: string;
};

export default Vue.extend({
  name: "RentalBookingAdditionalConditions",
  components: {
    PointerMenu,
    Loading,
  },
  props: {
    rentalItem: Object,
    data: Array as PropType<RentalConditionJson[]>,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      PriceUtils: PriceUtils,
      details: null as RentalConditionJson[] | null,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    init() {
      this.details = [...this.data];
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {},

  computed: {},
});
